<template >
  <div>
    <div class="menu-back-wrap">
      <div class="menu-back"></div>
    </div>
    <topnav></topnav>

    <div class="faq-page-wrap center">
      <h3 class="txt60 red">AdverGaming</h3>

      <div class="w1170">
        <!-- <div class="a-img-wrap"><img src="../assets/sp-lgo.png" /></div> -->
        <img class="sp-image" src="../assets/sp-lgo-2.jpg" />
        <p class="downcrd">she-ra tm character © mattel, lnc,; series © 2019 dreamworks animation llc, all other properties © 2019 dreamworks animation llc, all rights reserved</p>
      </div>
      <!-- <img src="../assets/pattern1 blue copy 2.svg" class="team-page-icon" /> -->



<h4 class="txt24 balance">Why Advergaming Works for Brands</h4>
<ul class="txt20 light start">
  <li class="pb-1"><strong>Increase Awareness:</strong> Games are a unique vehicle to immerse users in your brand’s world—creating memorable, shareable moments.</li>
  <li class="pb-1"><strong>Educate Through Play:</strong> With features like the Video Gallery, brands can showcase Social Media videos, commercials, or trailers directly inside the game experience.</li>
  <li class="pb-1"><strong>Drive Deep Engagement:</strong> Nothing beats games when it comes to engagement. Play.Works advergames average over 19 minutes of active playtime—far exceeding traditional ad formats.</li>
  <li class="pb-1"><strong>Call-to-Action Ready:</strong> Integrate branded video, product showcases, or even a “Tune-In Now” button—driving viewers from game to channel, site, or storefront.</li>
  <li class="pb-1"><strong>Built for Connected TV:</strong> Advergaming leverages the scale of television with the interactivity of mobile—reaching users in a lean-back, high-attention environment.</li>
</ul>
      <!-- <router-link to="/lets-play" class="btn bigger">Get in touch</router-link> -->
        <p class="txt20">Contact us today at</p>
          <a href="mailto:sales@play.works"  target="_blank" class="cont-small-link">sales@play.works</a>
    </div>





    <botfooter></botfooter>
  </div>
</template>

<script>
import Botfooter from "@/components/Botfooter.vue";
import Topnav from "@/components/Topnav.vue";
export default {
  components: {
    Topnav,
    Botfooter,
  },
  name: "AdverGaming",
};
</script>

<style>
.a-img-wrap {
  width: 80%;
  margin: -100px auto 30px;
  position: relative;
}

.sp-image {
  width: 100%;
  max-height: 45vh;
  /* margin-top: -100px; */
  margin-top: 2rem;
  object-fit: contain;
}

.downcrd {
  text-transform: uppercase;
  font-size: 11px;
  text-align: center;
  max-width: 560px;
  margin: 20px auto 60px;
}
</style>